var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"l-inline l-center-v l-padded l-spread"},[_c('div',{staticClass:"list-header__title"},[_vm._t("title",[_vm._v(" List Header ")])],2),_vm._t("accessory")],2),_c('div',[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }